import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../helpers/helper';
import { AlertasModales } from '../../helpers/alertasModales';
import { RutasService } from '../../services/rutas.service';
import { EmpleadosServicio } from '../../services/empleado.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CuadreService } from '../../services/cuadre.service';

import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-aperturar-dia',
  templateUrl: './aperturar-dia.component.html',
  styleUrls: ['./aperturar-dia.component.css']
})
export class AperturarDiaComponent implements OnInit {
  fechaApertura: NgbDateStruct;
  now = new Date(this.helper.getDate());
  rutas = [];
  empleados = [];
  form: FormGroup;
  loading = false;
  error = '';
  constructor(private helper: Helper,
              private route: Router,
              private rutaService: RutasService,
              private modals: AlertasModales,
              private cuadreService: CuadreService,
              private empleadoService: EmpleadosServicio) {
  this.fechaApertura = {
    year: this.now.getFullYear(),
    month: this.now.getMonth() + 1,
    day: this.now.getDate()};
    this.initForm();
    this.initRutas();
  }

  ngOnInit() {
    this.initEmpleados();
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas().subscribe(res => this.rutas = res.rutas);
  }

  private initEmpleados(): void {
    this.form.get('ruta').valueChanges.subscribe(res => {
      if (res) {
        this.empleadoService.empleadosPorRutasAsignadas(res)
        .subscribe(result => {
          this.empleados = result;
          this.form.get('empleado').enable();
        });
      } else {
        this.form.get('empleado').setValue('');
        this.form.get('empleado').disable();
        this.empleados = [];
      }
    });

  }

  private initForm(): void {
    this.form = new FormGroup({
      fecha_apertura: new FormControl({
        year: this.now.getFullYear(),
        month: this.now.getMonth() + 1,
        day: this.now.getDate()},
        Validators.required),
      ruta: new FormControl('', Validators.required),
      empleado: new FormControl('', Validators.required),
      dieta: new FormControl('400' , Validators.required),
      capital: new FormControl('', Validators.required),
      acompanante: new FormControl(''),
      nota_adicional: new FormControl(''),
      ID_EMPLEADO: new FormControl(this.empleadoService.datosEmpleado.ID_EMPLEADO, Validators.required),
    });

    if (!this.form.get('ruta').value) {
      this.form.get('empleado').disable();
    }
  }

  aperturarDia() {
    if (this.form.valid) {

      const currencyPipe = new CurrencyPipe('en-US');

      const html = `¿Desea aperturar el día con un capital de ${  currencyPipe.transform(this.form.get('capital').value,
        'RD$', 'symbol', '1.0-2') }?`;

      this.modals.confirmNgbModal(html, 'Apertura de día').then(resp => {
        if (resp && resp === 'si') {
          this.cuadreService.registrarAperturaDia(this.form.value).subscribe(res => {
            if (res) {
              this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-sun-o');
              this.form.get('ruta').setValue('');
              this.form.get('empleado').setValue('');
              this.form.get('dieta').setValue('400');
              this.form.get('capital').setValue('');
              this.form.get('acompanante').setValue('');
            }
          }, err => {
            if (err) {

              this.modals.errorModalJquery(this.route, err.apertura, '', '',
              'Esta ruta ya ha sido aperturada anteriormente para este día', 'Ver apertura', 'orange', 'modern', 'btn-orange', 'fa fa-sun-o');
            }
          });
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/aperturar-dia/aperturar-dia.component.ts